// SinglePropertyLayoutTab/components/EditFieldModal.js
import { __ } from '@wordpress/i18n';
import FieldOptions from '../FieldOptions';
import ModalHeader from '../ModalHeader';
import ModalOverlay from '../ModalOverlay';

const EditFieldModal = ({ 
  isOpen, 
  field, 
  area, 
  onClose, 
  onSave,
  modalOptions,
  usedFieldsInArea
}) => {
  if (!isOpen || !field) return null;

  // Get all available options for this area
  const areaOptions = modalOptions && area ? (modalOptions[area] || []) : [];
  
  // Filter out options that are already used in this area (EXCLUDING the current field being edited)
  const availableOptions = areaOptions.filter(option => {
    const optionType = option.type.toLowerCase();
    
    // Check if this option type is already used in the area (excluding current field)
    const isUsed = usedFieldsInArea.some(usedField => 
      usedField.id !== field.id && usedField.type.toLowerCase() === optionType
    );
    
    // Only show options that are NOT used (excluding current field)
    return !isUsed;
  });

  const handleReplace = (option) => {
    // Create a new field with the selected type
    const newField = {
      ...field,
      type: option.type.toLowerCase(),
      label: option.label
    };
    
    onSave(newField);
    onClose();
  };

  return (
    <ModalOverlay onClose={onClose}>
      <ModalHeader 
        title={__("Replace Field Type", "havenlytics")} 
        onClose={onClose} 
      />
      <div className="hvnly--builder---api_property__singleProperty__builder___option_card_body">
        {/* Enhanced Edit Mode Info */}
        <div className="hvnly--builder---api_property__singleProperty__builder___edit_mode_info">
          <i className="fas fa-exchange-alt"></i>
          <div className="hvnly--builder---api_property__singleProperty__builder___edit_mode_content">
            <span className="hvnly--builder---api_property__singleProperty__builder___edit_mode_title">
              {__("Replace Current Field", "havenlytics")}
            </span>
            <span className="hvnly--builder---api_property__singleProperty__builder___edit_mode_description">
              {__("Select a new field type to replace", "havenlytics")} <strong>"{field.label}"</strong>
            </span>
          </div>
        </div>

        {availableOptions.length > 0 ? (
          <div>
            <p className="hvnly--builder---api_property__singleProperty__builder___replace_info">
              {__("Your existing field content will be preserved. Only the field type will change.", "havenlytics")}
            </p>
            <FieldOptions 
              options={availableOptions}
              onSelect={handleReplace}
            />
          </div>
        ) : (
          <div className="hvnly--builder---api_property__singleProperty__builder___no_options">
            <i className="fas fa-exclamation-circle"></i>
            <p>{__("No available fields to replace with", "havenlytics")}</p>
            <small>{__("All other field types are already used in this area", "havenlytics")}</small>
          </div>
        )}
        
        <div className="hvnly--builder---api_property__singleProperty__builder___field_editor_actions">
          <button 
            className="hvnly--builder---api_property__singleProperty__builder___field_editor_btn hvnly--builder---api_property__singleProperty__builder___field_editor_cancel_btn"
            onClick={onClose}
          >
            {__("Cancel", "havenlytics")}
          </button>
        </div>
      </div>
    </ModalOverlay>
  );
};

export default EditFieldModal;